import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { calculateDiscountPercent, numberWithCommas } from "../../../utils/utility";
import { Divider, Grid, Rating } from "@mui/material";
import { IS_MOBILE } from "../../../constants/breakpoints";

//import images and icons
import { Star1 } from "iconsax-react";
import noImage from "../../../assets/imgs/no-image.png";

function RecommendedHotelItem({ topRatedHotels }) {
    //general variables
    let [_, setSearchParams] = useSearchParams();
    const { t } = useTranslation();

    //navigate to hotel details page
    const navigateToHotelDetails = (hotel, action) => {
        const { id, tag } = hotel;
        const params = { hotelId: id, tag, action };

        setSearchParams(params);
        sessionStorage.setItem("selectedHotel", JSON.stringify(hotel));
    };

    //check if a hotel has a discount
    const hasDiscount = hotelItem => {
        return hotelItem?.room_min_price?.prices?.has_off && hotelItem?.room_min_price?.prices?.total_board_price !== 0;
    };

    return (
        <Grid container item xs={12} rowGap={3} justifyContent="space-between" mt={{ xs: 3, md: 0 }}>
            {topRatedHotels.map((hotelItem, index) => {
                return (
                    <Grid
                        className="recommended-hotel__card"
                        key={Math.random()}
                        container
                        item
                        xs={12}
                        md={3.9}
                        xl={3.7}
                        justifyContent="space-between"
                        onClick={() => navigateToHotelDetails(hotelItem, IS_MOBILE ? "hotel-details" : "rooms")}
                    >
                        <span className="recommended-hotel__index">{index + 1}</span>
                        <Grid container item xs={12} md={4.5}>
                            <img
                                className="recommended-hotel__hotel-image"
                                src={hotelItem?.images.length ? `https://api.atripa.ir${hotelItem?.images[0]?.image}` : noImage}
                            />
                        </Grid>

                        <Grid
                            className="recommended-hotel__details"
                            container
                            item
                            xs={12}
                            md={7.5}
                            rowGap={{ xs: 1, md: 0 }}
                            columnGap={{ xs: 0, md: 1 }}
                            justifyContent={{ xs: "space-between", md: "flex-start" }}
                            alignItems="flex-start"
                        >
                            <Grid component="span" container item xs="auto">
                                {hotelItem.type} {hotelItem.name}
                            </Grid>

                            <Grid container item xs={6} justifyContent={{ xs: "flex-end", md: "flex-start" }}>
                                <Rating
                                    name="customized-color"
                                    defaultValue={hotelItem?.star}
                                    getLabelText={value => `${value} Heart${value !== 1 ? "s" : ""}`}
                                    icon={<Star1 size="20" color="var(--golden-color)" variant="Bold" />}
                                    emptyIcon={<Star1 size="20" color="var(--gray-color)" />}
                                    dir="ltr"
                                    readOnly
                                />
                            </Grid>
                            <Divider sx={{ width: { xs: "100%", md: 0 } }} />
                            <Grid component="span" container item xs={6} md={12}>
                                {t("priceStart")}:
                            </Grid>
                            <Grid component="span" container item xs={6} md={12} direction="column" justifyContent="flex-end" alignItems="flex-end">
                                <span className="recommended-hotel__offer-price">
                                    {numberWithCommas(hotelItem?.fare?.total)}&nbsp; {t("currency")}
                                </span>
                                {hasDiscount(hotelItem) && (
                                    <>
                                        <span className="recommended-hotel__origin-price">
                                            {numberWithCommas(hotelItem?.room_min_price?.prices?.total_board_price)} {t("currency")}
                                        </span>
                                        <span className="recommended-hotel__percent">
                                            <span>
                                                {calculateDiscountPercent(
                                                    hotelItem?.room_min_price?.prices?.total_board_price,
                                                    hotelItem?.room_min_price?.prices?.total_price,
                                                )}
                                            </span>
                                        </span>
                                    </>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                );
            })}
        </Grid>
    );
}

export default RecommendedHotelItem;
